import React from "react";
import { AddToListButton } from "@activecollab/components";
import PropTypes from "prop-types";

const AddToTaskTrigger = ({ handleOnClick, labelText, className }) => {
  return (
    <p className={className}>
      <AddToListButton
        text={labelText}
        onClick={handleOnClick}
        className="tw--ml-1"
      />
    </p>
  );
};

AddToTaskTrigger.propTypes = {
  handleOnClick: PropTypes.func.isRequired,
  labelText: PropTypes.string.isRequired,
  className: PropTypes.string,
};

AddToTaskTrigger.displayName = `AddToTaskTrigger`;

export default AddToTaskTrigger;
